import { ButtonV2 } from '@labrav/react-components'
import { FooterV2 } from '../../../common/components/FooterV2/FooterV2'
import { useStyles } from './ContractsV2FooterSubmit.styles'

export interface FooterV2SubmitProps {
  onSubmit: () => void
  onClear: () => void
  submitBtnTitle: string
  count: number
  totalAmount: number | null
}

export const ContractsV2FooterSubmit: React.FC<FooterV2SubmitProps> = ({
  onSubmit,
  onClear,
  submitBtnTitle,
  count,
  totalAmount,
}) => {
  const { classes } = useStyles()
  return (
    <div data-testid="contracts-v2-footer">
      <FooterV2
        width="100%"
        customClass={classes.footerCustomClass}
        actions={
          <div className={classes.root}>
            {count > 0 ? (
              <div className={classes.totalText}>
                <span className={classes.totalValue}>
                  Total amount to be metered for
                </span>{' '}
                <span className={classes.count}>{count}</span>{' '}
                <span className={classes.totalValue}>
                  {count > 1 ? 'buyers:' : 'buyer:'}
                </span>{' '}
                {totalAmount !== null ? (
                  <span data-testid={'total-amount-metered'}>
                    <span className={classes.dollar}>$</span>
                    <span className={classes.count}>
                      {totalAmount.toLocaleString('en-US', {
                        minimumFractionDigits: 3,
                        maximumFractionDigits: 3,
                      })}
                    </span>
                  </span>
                ) : (
                  <span
                    className={classes.totalValue}
                    style={{ paddingTop: '3px' }}
                  >
                    -
                  </span>
                )}
              </div>
            ) : (
              <div className={classes.totalValue}>
                Total amount to be metered --
              </div>
            )}
            <div className={classes.footerWrapper}>
              <div className={classes.clearFormButton}>
                <ButtonV2
                  data-testid="clear-form-btn"
                  styleType="outlined"
                  onClick={onClear}
                >
                  Clear form
                </ButtonV2>
              </div>
              <ButtonV2
                data-testid="submit-metering-btn"
                styleType="primary"
                onClick={onSubmit}
                disabled={count == 0}
              >
                {submitBtnTitle}
              </ButtonV2>
            </div>
          </div>
        }
      />
    </div>
  )
}
